import { parseRawNumber, formatNumber } from 'templates/IncomeAndExpendituresPageData/Utils/FormatNumbers'
import { formProgression } from 'common/helpers/Gtm';

interface Props {
    PageData?: any;
    formValues?: any;
    setFormValues?: any;
    currencyClass?: string;
}

const OtherDebt = ({
    PageData,
    formValues,
    setFormValues,
    currencyClass,
}: Props) => {

    let debtFormValues = { ...formValues.OtherDebtFormModel };

    let handleDebtCreditorChange = (i: number, e: string) => {
        debtFormValues.Debts[i]["debtCreditor"] = e;
        setFormValues({ ...formValues, OtherDebtFormModel: debtFormValues });
    };
    let handleDebtBalanceChange = (i: number, e: string) => {
        debtFormValues.Debts[i]["debtBalance"] = e;
        debtFormValues.totalDebtBalances = (formatNumber(((debtFormValues.Debts || []).reduce((total: any, curr: any) => total + parseRawNumber(curr.debtBalance, 2), 0)), ','));
        setFormValues({ ...formValues, OtherDebtFormModel: debtFormValues });
    };
    let handleDebtMonthlyPaymentChange = (i: number, e: string) => {
        debtFormValues.Debts[i]["debtMonthlyPayment"] = e;
        debtFormValues.totalDebtPayments = (formatNumber(((debtFormValues.Debts || []).reduce((total: any, curr: any) => total + parseRawNumber(curr.debtMonthlyPayment, 2), 0)), ','));
        setFormValues({ ...formValues, OtherDebtFormModel: debtFormValues });
    };

    let removeOtherDebtOnClick = (i: number) => {
        debtFormValues.Debts.splice(i, 1);
        debtFormValues.totalDebtBalances = ((debtFormValues.Debts || []).reduce((total: any, curr: any) => total + parseRawNumber(curr.debtBalance, 2), 0));
        debtFormValues.totalDebtPayments = ((debtFormValues.Debts || []).reduce((total: any, curr: any) => total + parseRawNumber(curr.debtMonthlyPayment, 2), 0));
        setFormValues({ ...formValues, OtherDebtFormModel: debtFormValues });
    };

    return (
        debtFormValues.Debts != null &&
        (debtFormValues.Debts?.map((element: any, index: number) => (
            <div className="OtherDebt__formRow" key={index}>
                <div className="OtherDebt__inputsWrapper">
                    <label className="IncomeAndExpenditure__label">
                        <span className="IncomeAndExpenditure__labelText">{PageData?.CreditorLabel}</span>
                        <div className="Input">
                            <input type="text" name={"debtCreditor" + index} placeholder={PageData?.CreditorNamePlaceHoldertext} onChange={e => handleDebtCreditorChange(index, e.target.value)} value={debtFormValues.Debts[index]["debtCreditor"]} onBlur={(e) => formProgression(e, 'I&E form', 'debtCreditor')} />
                        </div>
                    </label>

                    <label className="IncomeAndExpenditure__label">
                        <span className="IncomeAndExpenditure__labelText">{PageData?.BalanceLabel}</span>
                        <div className={"Input Input-icon Input-icon--before " + currencyClass}>
                            <input type="number" name={"debtBalance" + index} value={debtFormValues.Debts[index]["debtBalance"]} className="balance-to-calculate" placeholder={PageData?.InputAmountPlaceHolderText} onChange={e => handleDebtBalanceChange(index, e.target.value)} onBlur={(e) => formProgression(e, 'I&E form', 'debtBalance')}/>
                            <span>

                            </span>
                        </div>

                    </label>
                    <label className="IncomeAndExpenditure__label">
                        <span className="IncomeAndExpenditure__labelText">
                            {PageData?.MonthyPaymentAmountLabel}
                        </span>
                        <div className={"Input Input-icon Input-icon--before " + currencyClass}>
                            <input type="number" name={"debtMonthlyPayment" + index} value={debtFormValues.Debts[index]["debtMonthlyPayment"]} className="payment-to-calculate" placeholder={PageData?.InputAmountPlaceHolderText} onChange={e => handleDebtMonthlyPaymentChange(index, e.target.value)} onBlur={(e) => formProgression(e, 'I&E form', 'debtMonthlyPayment')}/>
                            <span>

                            </span>
                        </div>
                    </label>
                </div>
                <button type="button" className="OtherDebt__removeBtn remove-debt-btn" onClick={() => removeOtherDebtOnClick(index)}>
                    <span className="OtherDebt__removeBtnText">{PageData?.removeLabelText}</span>
                    <i className="OtherDebt__removeBtnIcon"></i>
                </button>
            </div>
        )
        ))
    );

};
export default OtherDebt;